export const colors = {
  flowblue1: '#D7E1FE',
  flowblue5: '#021C64',
  fuschia1: '#FADBF6',
  fuschia5: '#5A0C50',
  jade1: '#DCF9ED',
  jade5: '#0F5738',
  pumpkin1: '#FFE7D6',
  pumpkin5: '#662B03',
  purple1: '#E9DEF7',
  purple5: '#251042',
  raspberry1: '#FDD8E2',
  raspberry5: '#61051D',
  sky1: '#D6F0FF',
  sky5: '#004166',
  torqoise1: '#DAFBFB',
  torqoise5: '#0A5C5C',
  gold1: '#FFF1D6',
  gold5: '#664400'
}
